import { Stack, Group, Title, Paper } from '@mantine/core';
import { NavigationWrapper } from '../../components/navigation/NavigationWrapper';
import { ProfessionalCarousel } from './components/ProfessionalCarousel';
import { useState } from 'react';
import { useNavigate, createSearchParams } from 'react-router-dom';
import { ProfessionalSearchInput } from './components/ProfessionalSearchInput';
import { CategorySelector } from './components/CategorySelector';
import { LocalStorageKeys } from '../../constants/locationStorage';
import { PageRoutes } from '../../constants/routes';
import { useApp } from '../../context/AppContext';

export const NewSearch = () => {
  const onClickOption = (search: string) => {
    const updatedSearches = [
      search,
      ...recentSearches.filter((s) => s !== search),
    ];
    setRecentSearches(updatedSearches);
    localStorage.setItem(
      LocalStorageKeys.RECENT_SEARCHES,
      JSON.stringify(updatedSearches)
    );
    navigate(PageRoutes.SEARCH_RESULTS, { state: { searchText: search } });
  };

  const onCatergorySelect = (categoryName: string) => {
    navigate({
      pathname: PageRoutes.SEARCH_RESULTS,
      search: `?${createSearchParams({ categories: categoryName }).toString()}`,
    });
  };

  const [recentSearches, setRecentSearches] = useState<string[]>(
    localStorage.getItem(LocalStorageKeys.RECENT_SEARCHES)
      ? JSON.parse(
        localStorage.getItem(LocalStorageKeys.RECENT_SEARCHES) || '[]'
      )
      : []
  );
  const navigate = useNavigate();
  const { scrollAreaHeight, isTabletAndBelow } = useApp();

  return (
    <NavigationWrapper>
      <Paper
        shadow="xl"
        maw="1200px"
        mx="auto"
        radius="md"
        mih={isTabletAndBelow ? scrollAreaHeight : undefined}
      >
        <Stack bg="white" p="lg">
          <Group justify="center" pt="20px">
            <ProfessionalSearchInput
              onClickOption={onClickOption}
              redirectOnClear={false}
            />
          </Group>
          <Title
            order={3}
            fw="normal"
            data-testid={SearchPageTestIds.PEOPLE_OF_INTEREST_TITLE}
          >
            Suggested for You
          </Title>
          <ProfessionalCarousel />
          <Title
            order={3}
            fw="normal"
            data-testid={SearchPageTestIds.SEARCH_BY_CATEGORY_TITLE}
          >
            Search by Category
          </Title>
          <CategorySelector onClickOption={onCatergorySelect} />
        </Stack>
      </Paper>
    </NavigationWrapper>
  );
};

export const SearchPageTestIds = {
  PEOPLE_OF_INTEREST_TITLE: 'people-of-interest-title',
  SEARCH_BY_CATEGORY_TITLE: 'search-by-category-title',
};
